import React, { createContext, useContext } from "react";
import { useJsApiLoader } from "@react-google-maps/api";

interface GoogleMapsContextType {
  isLoaded: boolean;
  google: typeof window.google | null;
}

const GoogleMapsContext = createContext<GoogleMapsContextType>({
  isLoaded: false,
  google: null,
});

const libraries: ("geometry" | "places")[] = ["geometry", "places"];

export const GoogleMapsLoaderProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAP_API_KEY || "",
    libraries,
    version: "weekly",
  });

  return (
    <GoogleMapsContext.Provider value={{ isLoaded, google: isLoaded ? window.google : null }}>
      {children}
    </GoogleMapsContext.Provider>
  );
};

export const useGoogleMaps = () => useContext(GoogleMapsContext);
